// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"625":"48384a48","693":"b65297f4"}[chunkId] + ".chunk.css";
};